import {
  AppstoreOutlined,
  BellOutlined,
  CalendarOutlined,
  FileTextOutlined,
  MessageOutlined,
  PlayCircleOutlined,
  TagsOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Spin } from "antd";
import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { MainLayout } from "../../components/Layouts/MainLayout";
import { useAuth } from "../../hooks/useAuth";
import { ContactsPage } from "./Contacts/pages/ContactsPage";
import Announcements from "./Announcements/Announcement";
import Posts from "./Posts/Post";
import { PostTypesPage } from "./PostTypes/page/PostTypesPage";
import { TagsPage } from "./Tags/page/TagsPage";
import { UserPage } from "./Users/page/UserPage";
import { VideosPage } from "./Videos/page/VideosPage";

const navList = [
  {
    key: "/bang-dieu-khien/su-kien",
    label: "Sự kiện",
    icon: <CalendarOutlined />,
  },
];

// Full navList for admin and staff
const fullNavList = [
  {
    key: "/bang-dieu-khien/su-kien",
    label: "Sự kiện",
    icon: <CalendarOutlined />,
  },
  {
    key: "/bang-dieu-khien/tin-tuc",
    label: "Tin tức",
    icon: <FileTextOutlined />,
  },
  {
    key: "/bang-dieu-khien/video",
    label: "Video",
    icon: <PlayCircleOutlined />,
  },
  {
    key: "/bang-dieu-khien/lien-he",
    label: "Liên hệ",
    icon: <MessageOutlined />,
  },
  {
    key: "/bang-dieu-khien/thong-bao",
    label: "Thông báo",
    icon: <BellOutlined />,
  },
];

const categoryList = [
  {
    key: "/bang-dieu-khien/loai-tin-tuc",
    label: "Loại tin tức",
    icon: <AppstoreOutlined />,
  },
  {
    key: "/bang-dieu-khien/tags",
    label: "Tags",
    icon: <TagsOutlined />,
  },
];

const Events = lazy(() => import("./Events/Event"));

export default function Main() {
  const { data: user } = useAuth();

  // Assistant role: only see events
  // Admin and staff: see full features

  const isAdminOrStaff = user?.role === "admin" || user?.role === "staff";

  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spin size="large" tip="Đang tải nội dung..." />
        </div>
      }
    >
      <MainLayout
        navList={
          user?.role === "admin"
            ? fullNavList.concat({
                key: "/bang-dieu-khien/nguoi-dung",
                label: "Người dùng",
                icon: <UserOutlined />,
              })
            : user?.role === "staff"
              ? fullNavList
              : navList
        }
        categoryList={isAdminOrStaff ? categoryList : []}
      >
        <Routes>
          <Route index element={<Navigate to="su-kien" />} />
          <Route path="su-kien/*" element={<Events />} />

          {isAdminOrStaff && (
            <>
              <Route path="tin-tuc/*" element={<Posts />} />
              <Route path="loai-tin-tuc" element={<PostTypesPage />} />
              <Route path="video" element={<VideosPage />} />
              <Route path="lien-he" element={<ContactsPage />} />
              <Route path="thong-bao/*" element={<Announcements />} />
              <Route path="tags" element={<TagsPage />} />
            </>
          )}

          {user && user.role === "admin" && (
            <Route path="nguoi-dung" element={<UserPage />} />
          )}
        </Routes>
      </MainLayout>
    </Suspense>
  );
}
